import {
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  SelectProps,
  FormControlProps,
  MenuItem,
  MenuItemProps,
} from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

export type SelectOption = {
  value: string;
  label: string;
};

type FormSelectFieldProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  options: SelectOption[];
  label?: string;
  error?: boolean;
  helperText?: string;
  FormControlProps?: FormControlProps;
  SelectProps?: Omit<SelectProps, 'label' | 'error'>;
  MenuItemProps?: MenuItemProps;
};

const FormSelectField = <T extends FieldValues>({
  name,
  control,
  options,
  label,
  error,
  helperText,
  FormControlProps,
  SelectProps,
  MenuItemProps,
}: FormSelectFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControl error={error} {...FormControlProps}>
          {label && <InputLabel id={`${name}-label`}>{label}</InputLabel>}
          <Select
            {...field}
            value={field.value ?? ''}
            labelId={label ? `${name}-label` : undefined}
            label={label}
            {...SelectProps}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value} {...MenuItemProps}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default FormSelectField;
